import { memo } from 'react';
import { TextMessageBubble, Translation, TranslatedStatus } from 'components/Dialogue';
import EnhanceText from 'components/Dialogue/components/Message/EnhanceText';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { getMetaFromSender } from '../../utils';
import { useChatContext } from '../../contexts/ChatContext';
import { useGetTranslation } from './TextMsg';
import { BaseMsgProps } from './types';

export const JolectFixedReplyMsg = memo((props: BaseMsgProps) => {
  const { msg, raw } = props;
  const { singleTransToSysLang } = useChatContext();
  const { getTranslation } = useGetTranslation();
  const text = raw.jlFixedReplyContent?.text;
  const translation = getTranslation(raw.jlFixedReplyContent?.translationContent);

  if (!text) {
    return null;
  }

  const { layout, color } = getMetaFromSender(msg.sender);

  return (
    <MessageExtendComplex
      {...props}
      showSourceContent={false}
      content={
        <TextMessageBubble
          color={color}
          className={layout}
          extra={
            raw.hideTranslate ? null : (
              <>
                <Translation msg={raw} layout={layout} translation={translation} />
                <TranslatedStatus
                  onTranslate={() => singleTransToSysLang(raw)}
                  status={
                    translation && !translation.text && translation.status === 'success'
                      ? 'error'
                      : translation?.status
                  }
                  translated={translation?.translated}
                />
              </>
            )
          }
        >
          <EnhanceText text={text} platform={raw.channel} />
        </TextMessageBubble>
      }
    />
  );
});
